import { Link } from '@tanstack/react-router'
import { JianLogo } from '@/components/brand/jian-logo'
import { useAuthSessionStore } from '@/features/auth/stores/auth-session-store'
import { footerColumns, legalLinks, socialLinks } from './site-data'

const socialIconMap: Record<string, string> = {
  youtube: '▶',
  tiktok: '♪',
  instagram: '◎',
  facebook: 'f',
  x: '𝕏',
  linkedin: 'in',
}

export function SiteFooter() {
  const session = useAuthSessionStore((state) => state.session)
  return (
    <footer className="border-t border-border bg-background">
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6">
        <div className="grid gap-8 lg:grid-cols-[1fr_2fr]">
          {/* Left: logo + social */}
          <div>
            <Link to="/" className="flex items-center">
              <JianLogo size="md" />
            </Link>
            <p className="mt-4 max-w-xs text-sm text-muted-foreground">
              一份素材，产出多平台可直接发布的视频版本。
            </p>
            <div className="mt-4 flex gap-3">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex size-9 items-center justify-center rounded-full border border-border text-muted-foreground transition-colors hover:border-primary hover:text-primary"
                  aria-label={social.label}
                >
                  <span className="text-sm">{socialIconMap[social.icon]}</span>
                </a>
              ))}
            </div>
          </div>

          {/* Right: link columns */}
          <div className="grid grid-cols-2 gap-8">
            {footerColumns.map((column) => (
              <div key={column.title}>
                <h3 className="text-sm font-semibold text-foreground">{column.title}</h3>
                <ul className="mt-4 space-y-3">
                  {column.links.map((link) => {
                    const isExternal = link.isExternal ?? link.href.startsWith('http')
                    if (isExternal) {
                      return (
                        <li key={link.label}>
                          <a
                            href={link.href}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-sm text-muted-foreground transition-colors hover:text-foreground"
                          >
                            {link.label}
                          </a>
                        </li>
                      )
                    }
                    return (
                      <li key={link.label}>
                        <Link
                          to={link.href === '/app' ? (session ? '/app' : '/register') : link.href}
                          className="text-sm text-muted-foreground transition-colors hover:text-foreground"
                        >
                          {link.label}
                        </Link>
                      </li>
                    )
                  })}
                </ul>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-border pt-6 sm:flex-row">
          <p className="text-xs text-muted-foreground">© 2026 JIAN 保留所有权利</p>
          <div className="flex gap-6">
            {legalLinks.map((link) => (
              <span key={link.label} className="text-xs text-muted-foreground">
                {link.label}
              </span>
            ))}
          </div>
        </div>
      </div>
    </footer>
  )
}
